/* istanbul ignore file */
import React from 'react';
import PropTypes from 'prop-types';
import ScrollAnimation from 'react-animate-on-scroll';
import './StudioQuote.css';

const StudioQuote = ({ textColor, quote, author, position }) => {
    const textStyle = { color: textColor };

    return (
        <section className="section studio-quote-view">
            <div className="big-quote-container text-centered color-darkblue">
                {/* <ScrollAnimation duration={1.2} animateOnce={true} animateIn={'fadeInUp'} initiallyVisible={false}> */}
                    <div className="big-quote" style={textStyle} dangerouslySetInnerHTML={quote} />
                {/* </ScrollAnimation>
                <ScrollAnimation duration={1.3} delay={300} animateOnce={true} animateIn={'fadeInUp'} initiallyVisible={false}> */}
                    <div className="big-quote-author" style={textStyle}>
                        {author}
                    </div>
                {/* </ScrollAnimation>
                <ScrollAnimation duration={1.4} delay={500} animateOnce={true} animateIn={'fadeInUp'} initiallyVisible={false}> */}
                    <div className="big-quote-title" style={textStyle}>
                        {position}
                    </div>
                {/* </ScrollAnimation> */}
            </div>
        </section>
    );
};

StudioQuote.propTypes = {
    textColor: PropTypes.string.isRequired,
    quote: PropTypes.object.isRequired,
    author: PropTypes.string.isRequired,
    position: PropTypes.string.isRequired,
};

export default StudioQuote;
